/**
 * Function to show error overlay globally.
 * @param {String} errros Errors list to show.
 * @param {Boolean} isError Boolean to control if the message is an error.
 */
export function showErrorOverlay(errors, isError = true) {
  return {
    type: 'SHOW_ERROR_OVERLAY',
    payload: {
      errors,
      isError,
      isOpened: true
    }
  };
}

/**
 * Function to clear error overlay.
 */
export function clearErrorOverlay() {
  return {
    type: 'CLEAR_ERROR_OVERLAY'
  };
}
